import React from 'react'
import {
  CalendarIcon,
  MapPinIcon,
  UsersIcon,
  MoreVerticalIcon,
} from 'lucide-react'
import { StatusBadge } from './StatusBadge'
import { useNavigate } from "react-router";

export const JobCard = ({ job }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
      <div className="p-5">
        <div className="flex justify-between">
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 truncate">
            {job.title}
          </h3>
          <div className="relative">
            <button className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300">
              <MoreVerticalIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{job.department}</p>
        <div className="mt-4">
          <StatusBadge status={job.is_active ? 'Active' : 'Closed'} />
        </div>
        <div className="mt-6 flex items-center text-sm text-gray-500 dark:text-gray-400">
          <MapPinIcon className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" />
          <span>{`${job.city || "City"}, ${job.country || "Country"}`}</span>
        </div>
        <div className="mt-2 flex items-center text-sm text-gray-500 dark:text-gray-400">
          <CalendarIcon className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" />
          <span>Posted on {new Date(job.created_at).toLocaleDateString()}</span>
        </div>
        {/* <div className="mt-2 flex items-center text-sm text-gray-500 dark:text-gray-400">
          <UsersIcon className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" />
          <span>{job.applicants} applicants</span>
        </div> */}
        <div className="mt-5 flex justify-between items-center">
          {/* {job.daysLeft > 0 ? (
            <span className="text-sm font-medium text-gray-500">
              {job.daysLeft} days left
            </span>
          ) : (
            <span className="text-sm font-medium text-gray-500">-</span>
          )} */}
          <button className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-blue-600 hover:bg-blue-700" onClick={() => navigate(`/jobpost/${job.id}`)}>
            View Details
          </button>
        </div>
      </div>
    </div>
  )
}
